(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mobile-store-locations"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  // Find alle titler i collage / image-blocks og skift H1 -> H2
  document.querySelectorAll('.image-block__title.h5').forEach(function (el) {
    if (el.tagName.toLowerCase() === 'h1') {
      const h2 = document.createElement('h2');

      // kopier klasser og indhold
      h2.className = el.className;
      h2.innerHTML = el.innerHTML;

      // kopier øvrige attributter (id, aria-*, data-*)
      Array.from(el.attributes).forEach(function (attr) {
        if (attr.name !== 'class') h2.setAttribute(attr.name, attr.value);
      });

      el.replaceWith(h2);
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
